/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeWhiteChartAxisBase } from "./d-theme-white-chart-axis-base";

export class DThemeWhiteChartAxisX extends DThemeWhiteChartAxisBase {}
